import { IoChevronBack, IoChevronForward } from "react-icons/io5";
/* eslint-disable no-unused-vars */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Tabbar } from "../compornents/Tabbar";
import { toast } from 'react-toastify';
import { Post } from '../compornents/Post';
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { Analytics } from '../compornents/Analytics';
import { useAtom } from 'jotai';
import { customerAtom } from '../auth';

import 'react-toastify/dist/ReactToastify.css';

export const Other = () => {
  const navigate = useNavigate();
  const [customer, setCustomer] = useAtom(customerAtom);
  // 販促・お知らせ配信のオプトイン切替（オプトアウト導線）。
  const toggleMarketing = async (checked) => {
    try {
      const res = await Post('post', '/customer/set_flag.php', { type: 'is_marketing_optin', value: checked ? 1 : 0 });
      if (res.result === 1) {
        if (res.customer) setCustomer(res.customer);
        toast.success(checked ? 'お知らせ・クーポンを受け取ります' : '配信を停止しました');
      } else {
        toast.error(res.error_message || '設定の変更に失敗しました');
      }
    } catch (e) {
      toast.error('通信に失敗しました');
    }
  };
  // モーダル
  const [LoadingModal, openLoadingModal, closeLoadingModal] = useModal('root', {
//    preventScroll: true //これはオプション。デフォルトはfalse
  });
  // メニュー選択
  const selectMenu = (menu) => {
    // console.log(menu);
    if(menu==='logout'){
      // 通知
      toast.success("ログアウトしました");
      logout();
    } else {
      navigate("/" + menu);
    }
    // navigate("/order/" + menu);
  };
  async function logout() {
    openLoadingModal();
    const request_data = {}
    await Post('logout', '', request_data);
    setTimeout(() => { navigate("/login") }, 1500);
    closeLoadingModal();
  }
  // 戻る
  const back = () => {
    navigate("/account");
  };
  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="App">
      <div className="Other">
        <Analytics title="その他" />
        <div className="mb-5">
          <div className="toolbar mb-3">
            <div className="toolbar_left div_btn" onClick={back} >
              <IoChevronBack />
            </div>
            <div className="toolbar_center">
              その他
            </div>
            <div className="toolbar_right">
            </div>
          </div>
          <div className="other_list">
            <div className="other" style={{ cursor: 'default' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '0 1.5rem 0 2rem' }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ color: 'var(--ink)', fontWeight: 500 }}>お知らせ・クーポンの受信</div>
                  <div style={{ fontSize: 12, color: '#999', marginTop: 2 }}>SMS／メールでの販促・お得情報の配信</div>
                </div>
                <label style={{ position: 'relative', display: 'inline-block', width: 46, height: 26, margin: 0, flex: '0 0 auto' }}>
                  <input
                    type="checkbox"
                    checked={Number(customer?.is_marketing_optin) === 1}
                    onChange={(e) => toggleMarketing(e.target.checked)}
                    style={{ opacity: 0, width: 0, height: 0 }}
                  />
                  <span style={{
                    position: 'absolute', cursor: 'pointer', inset: 0, borderRadius: 26,
                    background: Number(customer?.is_marketing_optin) === 1 ? '#ffd60a' : '#ccc', transition: '.2s',
                  }}>
                    <span style={{
                      position: 'absolute', height: 20, width: 20, left: Number(customer?.is_marketing_optin) === 1 ? 23 : 3,
                      bottom: 3, background: '#fff', borderRadius: '50%', transition: '.2s', boxShadow: '0 1px 2px rgba(0,0,0,.3)',
                    }} />
                  </span>
                </label>
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('company')}>
              <div className="other_content">
                運営会社
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('privacy')}>
              <div className="other_content">
                プライバシーポリシー
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('rule')}>
              <div className="other_content">
                利用規約
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('tokutei')}>
              <div className="other_content">
                特定商取引法
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('baisyo')}>
              <div className="other_content">
                賠償基準について
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('customer_service')}>
              <div className="other_content">
                カスタマーサービス問い合わせ
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('logout')}>
              <div className="other_content">
                ログアウト
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
            <div className="other div_btn" onClick={() => selectMenu('leave')}>
              <div className="other_content">
                退会
              </div>
              <div className="other_arrow">
                <IoChevronForward />
              </div>
            </div>
          </div>
        </div>
        <LoadingModal>
          <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
            <button onClick={closeLoadingModal} className="hide">閉じる</button>
            <div >
              <TailSpin stroke="#000" />
            </div>
            <div className="">
              <div className="">
                処理中です
              </div>
            </div>
          </div>
        </LoadingModal>
        <Tabbar menu="account" />
      </div>

    </div>
  );
}
